import {
  parse as parseQS,
  stringify as stringifyQS,
  IStringifyOptions,
  IParseOptions,
} from 'qs';

export function stringify(obj: any, options?: IStringifyOptions): string {
  return stringifyQS(obj, {indices: false, ...options});
}

export function parse(obj: string, options?: IParseOptions): any {
  return parseQS(obj, {ignoreQueryPrefix: true, ...options});
}

const queryString = {
  stringify,
  parse,
};

export default queryString;
